//接口
//引入axios 
import request from '../utils/request'// 这里是引入咱们的axios用axios来进行异步接口请求
 
//比如说接口为注册接口
export function add(data){
    return request({
        url:'/apk/add',
        method:'post',
        data
    })
}

export function getList(data){
    return request({
        url:'/apk/getList',
        method:'post',
        data,
    })
}

export function getUserById(params){
    return request({
        url:'/apk/getUserById',
        method:'get',
        params,
    })
}

export function updateStatus(data){
    return request({
        url:'/apk/updateStatus',
        method:'post',
        data,   //一般get请求，我们习惯使用params属性来传参
 
    })
}
 
export function login(params){
    return request({
        url:'/apk/login',
        method:'get',
        params,   //一般get请求，我们习惯使用params属性来传参
 
    })
}

export function logout(){
    return request({
        url:'/apk/logout',
        method:'get',
    })
}

export function getCode(){
    return request({
        url:'/apk/captcha/calculateCode',
        method:'get',
    })
}

export function updatePassword(data){
    return request({
        url:'/apk/updatePassword',
        method:'post',
        data
    })
}
 
 
//以上为案例